<template>
  <content-editor
    :permission="'reference'"
    :fields="fields"
    :endpoint="'reference'"
    :updatePossible="true"
    publication
    reference
    :hasAuthor="false"
    previewModule="referenties"
    :module="'reference'"
  >
  </content-editor>
</template>

<script>

import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';
import common from '../common';

export default {
  mixins: [
    common,
    ContentDetail,
  ],
  data() {
    return {
      module: 'reference',
      endpoint: 'reference',
      fields: [
        {
          name: 'name',
          required: true,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'lightbox',
          required: false,
        },
        {
          name: 'read-confirmation',
          required: false,
        },
        {
          name: 'intro',
          required: true,
        },
        {
          name: 'targets',
          required: true,
        },
        {
          name: 'image',
          required: true,
        },
        {
          name: 'online',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'city',
          required: true,
        },
        {
          name: 'street',
          required: false,
        },
        {
          name: 'streetnumber',
          required: false,
        },
        {
          name: 'zipcode',
          required: false,
        },
        {
          name: 'map',
          required: true,
        },
        {
          name: 'implementation',
          required: true,
        },
        {
          name: 'client',
          required: true,
        },
        {
          name: 'branches',
          required: true,
        },
        {
          name: 'tags',
          required: false,
        },
        {
          name: 'delivery_date',
          required: false,
        },
        {
          name: 'architect',
          required: false,
        },
        {
          name: 'architectural_design',
          required: false,
        },
        {
          name: 'project_scope',
          required: false,
        },
        {
          name: 'contractor',
          required: false,
        },
        {
          name: 'installer',
          required: false,
        },
        {
          name: 'counselor',
          required: false,
        },
        {
          name: 'consultant',
          required: false,
        },
        {
          name: 'order_number',
          required: false,
        },
        {
          name: 'building_code',
          required: false,
        },
        {
          name: 'seo_keywords',
          required: false,
        },
      ],
    };
  },
  components: {
    ContentEditor,
  },
};
</script>
